import { Pipe, PipeTransform } from '@angular/core';
import { ISO_3166_1_CODES } from '@app/modules/authentication/multifactor-authentication/country-codes';

@Pipe({
  name: 'flag',
})
export class FlagCountryPipe implements PipeTransform {
  countyCodes = ISO_3166_1_CODES;
  transform(value: any, ...args: any[]) {
    const code = this.countyCodes.filter((element) => {
      return element.country.toLocaleLowerCase() == value.toLocaleLowerCase();
    });

    return code[0].code;
  }
}
